import { cx } from '@linaria/core';
import { useEffect, useRef } from 'react';
import { trackLoginInteraction } from '../../mfcLogic/lens';
import { useScreenStateSelector } from '../Hooks/useScreenState';
import "./ButtonLoginGoogle.linaria.module.css!=!./ButtonLoginGoogle?./ButtonLoginGoogle.linaria.module.css?css=H4sIAAAAAAAAAzXKQQqAIBAAwHt/STKSQB8jZVtKW1sqWUh/Dw+dZ9gQN70GzcV1puQzXeBnpCStmybY1VuxMqDV/MEDxJ4tuMVG2TXH/WsfNZpAYcyGkHwdjIUNJJao3uoDb0dl/GQAAAA="
const signinStyles = "atm_ks_15vqwwr atm_e2_1ylpe5n";
const formStyles = "atm_7t_lcsosb atm_e2_1ylpe5n";
const ButtonLoginGoogle = ({
  embedded,
  signup
}) => {
  const windowWidth = useScreenStateSelector('windowWidth');
  const googleSSOFormRef = useRef<HTMLFormElement>(null);
  useEffect(() => {
    const form = googleSSOFormRef.current;
    if (!form) return;
    const onFormData = () => {
      trackLoginInteraction(signup, 'google');
    };
    form.addEventListener('formdata', onFormData);
    return () => form.removeEventListener('formdata', onFormData);
  }, [signup]);
  return <form ref={googleSSOFormRef} id="gsi-sso" method="POST" action="https://www.myfreecams.com/php/login.php" className={formStyles}>
            <input type="hidden" name="submit_login" value="1" />
            <input type="hidden" name="load" value="app" />
            <input type="hidden" name="mode" value="app" />
            <input type="hidden" name="client_id" value="1101" />
            <input type="hidden" id="google_auth_json" name="google_auth_json" />
            <div id="g_id_onload" data-client_id="573756009040-069tuma22jeh5mjn4lshq0482uehh890.apps.googleusercontent.com" data-itp_support="false" data-callback="Google_onSignIn" />
            <div data-type="standard" data-width={windowWidth > 480 ? 432 : embedded ? windowWidth - 100 : windowWidth - 48} data-height="22" data-shape="rectangular" data-text={signup ? 'signup_with' : 'signin_with'} data-size={'large'} data-logo_alignment="center" data-theme="outline" className={cx('g_id_signin', signinStyles)} />
        </form>;
};
export default ButtonLoginGoogle;